import type { EmblaCarouselType } from 'embla-carousel';
import type { InjectionKey, Ref } from 'vue';

export interface Context {
  emblaApi: Ref<EmblaCarouselType | null>;
  currentPage: Ref<number>;
  canScrollPrev: Ref<boolean>;
  canScrollNext: Ref<boolean>;
  slidesPerPage: Ref<number>;
  pages: Ref<number[]>;
  isPlaying: Ref<boolean>;
  scrollTo: (index: number, jump?: boolean) => void;
  scrollPrev: () => void;
  scrollNext: () => void;
}

export const CONTEXT_KEY = Symbol('CarouselContext') as InjectionKey<Context>;
